import React, { FC, ReactElement, useEffect, useState } from "react";
import { BackgroundImage, Container } from "./styles";
import BoxWithHeading from "./BoxWithHeading";
import Jobs from "./Jobs";
import { useCustomJobQuery } from "../../services/customSiteQueries";
import { Job } from "../CareersSection/type";
import { colors } from "src/variables";
import { careers, bannerImages } from "./constant";
import BreakBarrier from "./BreakBarrier";

const Career: FC = ({}): ReactElement => {
  const [jobData, setJobData] = useState<
    Array<{ jobTitle: string; applyUrl: string }>
  >([]);
  const [allJobs, setAllJobs] = useState<
    Array<{ jobTitle: string; applyUrl: string }>
  >([]);
  const [visibleJobs, setVisibleJobs] = useState(5); // Show first 5 jobs
  const [noResults, setNoResults] = useState(false); // Track if search has no matches
  const response = useCustomJobQuery();

  //Data from page builder
  const { imageUrl, mobileImageUrl, headings } = careers;

  // Function to update job list
  const updateData = () => {
    let jobList =
      response.data?.Jobs.map((item: Job) => ({
        jobTitle: item.JobTitle,
        applyUrl: item.ApplyUrl,
      })) || [];

    setJobData([...jobList]); // Show initially
    setAllJobs([...jobList]); // Keep full list for search
    setNoResults(false); // Reset no results state
  };

  const searchData = (param: string) => {
    const searchQuery = param.toLowerCase().trim();

    if (!searchQuery) {
      updateData(); // Reset if empty
      setVisibleJobs(5);
    } else {
      const filteredList = allJobs.filter((item) =>
        item.jobTitle.toLowerCase().includes(searchQuery)
      );
      setJobData(filteredList.length ? [...filteredList] : []);
      setNoResults(filteredList.length === 0);
      setVisibleJobs(5);
    }
  };

  useEffect(() => {
    if (!jobData.length && !noResults) {
      updateData();
    }
  }, [response]);

  const loadMoreJobs = () => {
    setVisibleJobs((prev) => prev + 5);
  };

  return (
    <>
      <BreakBarrier
        bannerImages={bannerImages}
        backgroundColor={colors.white}
      />
      <Container backgroundColor={colors.white}>
        <BackgroundImage
          src=""
          webImageSrc={imageUrl}
          mobileImageSrc={mobileImageUrl}
        />
        <BoxWithHeading headings={headings}>
          <Jobs
            jobData={jobData}
            searchData={searchData}
            noResults={noResults}
            visibleJobs={visibleJobs}
            loadMoreJobs={loadMoreJobs}
            isLoading={response?.isLoading}
            error={response?.error}
          />
        </BoxWithHeading>
      </Container>
    </>
  );
};

export default Career;
